import { VStack } from "@chakra-ui/react";

import Pagination from "./Pagination";
import ResultsSummary from "./ResultsSummary";

interface PaginationWrapperProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  startIndex: number;
  endIndex: number;
  totalItems: number;
  itemType: string;
}

const PaginationWrapper = ({
  currentPage,
  totalPages,
  onPageChange,
  startIndex,
  endIndex,
  totalItems,
  itemType
}: PaginationWrapperProps) => {
  if (totalItems === 0) {
    return null;
  }

  return (
    <VStack gap={4} mt={4}>
      <ResultsSummary startIndex={startIndex} endIndex={endIndex} totalItems={totalItems} itemType={itemType} />
      <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
    </VStack>
  );
};

export default PaginationWrapper;
